/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Suggestions_Will_Replace_WithInputs */



/**
* | output |
* | --- |
* | "Will replace with:" |
*
* @param {Suggestions_Will_Replace_WithInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const suggestions_will_replace_with = /** @type {((inputs?: Suggestions_Will_Replace_WithInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Suggestions_Will_Replace_WithInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird ersetzt durch:")
	return /** @type {LocalizedString} */ ("Will replace with:")
});